import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "src/lib/store/store";
import { TestState } from "./test.type";
import { QuestionData } from "src/lib/endpoints/question/question.type";

const initialState: TestState = {
  result: null,
  questionData: null
};

const slice = createSlice({
  name: "test",
  initialState,
  reducers: {
    addResult: (state, { payload }) => {
      state.result = payload;
    },
    addQuestions: (state, { payload }) => {
      state.questionData = payload;
    },
    // removeSelectedJob: (state) => {
    //   return { ...state, selectedJob: null };
    // },
  },
});

export const { addResult, addQuestions } = slice.actions;
export default slice.reducer;

export const selectTestState: (state: RootState) => TestState = (
  state: RootState
) => state.test;
